import { Controller } from '@hotwired/stimulus';
import '../redactor/redactor.min';
import '../redactor/plugins/alignment/alignment.min';
import '../redactor/plugins/fontcolor/fontcolor.min';
import '../redactor/plugins/fontsize/fontsize.min';
import '../redactor/plugins/fullscreen/fullscreen.min';
import '../redactor/plugins/table/table.min';
import '../redactor/plugins/video/video.min';

export default class RedactorController extends Controller {
  connect() {
    this.initializeEditors();

    window.addEventListener('nestedElementAdded', () => {
      this.initializeEditors();
    });
  }

  initializeEditors() {
    const csrfToken = document.querySelector('meta[name=csrf-token]')?.content;
    const csrfParam = document.querySelector('meta[name=csrf-param]')?.content;
    const csrf = csrfToken && csrfParam ? `${csrfParam}=${encodeURIComponent(csrfToken)}` : '';
    var imageUploadURL = `/redactor/image_upload?${csrf}`;

    this.element.querySelectorAll('.redactor').forEach((el) => {
      if (!el._redactorInitialized) {
        $R(el, {
          plugins: ["fontcolor", "fontsize", "alignment", "fullscreen", "table", "video"],
          buttons: [
            "format",
            "redo",
            "undo",
            "fontcolor",
            "fontsize",
            "bold",
            "italic",
            "underline",
            "deleted",
            "lists",
            "table",
            "image",
            "link",
            "alignment",
            "html",
            "video"
          ],
          formatting: ["p", "blockquote"],
          imageUpload: imageUploadURL,
          imagePosition: true,
          imageResizable: true,
          lang: "fr"
        });
        el._redactorInitialized = true;
      }
    });
  }
}
